import Axios from 'axios';
import Qs from 'qs';
import abbr from './abbr';
import { JSEncrypt } from "jsencrypt";
let publicKey = abbr.publicKey;
var jsencrypt = new JSEncrypt();
jsencrypt.setPublicKey(publicKey);

let baseApi;
let curEnv = process.env.NODE_ENV;
if (curEnv === 'development') {
    baseApi = '/api';
} else {
    baseApi = window.paramConfig.api;
}
let userObj = localStorage.getItem('userObj');

let token='';
if(userObj){
    token = JSON.parse(userObj).stuToken;
}

var instance = Axios.create({
    headers: {
        'content-type': 'application/x-www-form-urlencoded',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': true,
        'token':token
    }
})

//添加请求拦截器
instance.interceptors.request.use(function(config) {
    // 在发送请求之前做些什么
    return config;
}, function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
instance.interceptors.response.use(function(response) {
    // 对响应数据做点什么
    return response;
}, function(error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});
export default instance;


//登录
export const apiLogin = params => {
        return new Promise((resolve, reject) => {
            instance.post(
                    baseApi + '/user/loginData',
                    Qs.stringify({
                        username: jsencrypt.encrypt(params.username),
                        password: jsencrypt.encrypt(params.password),
                        /* username: params.username,
                        password: params.password, */
                        appId:'3b97aa685f53431b9b31d98b6a0f9bcc',
                        auto: params.auto,
                        publicKey: publicKey,
                        type: 1
                    })
                )
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
    //退出登录
export const apiLoginOut = params => {
        return new Promise((resolve, reject) => {
            instance.post(
                    baseApi + '/user/loginOut'
                )
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
    //获取验签
export const apisigncode = params => {
        return new Promise((resolve, reject) => {
            instance.post(
                    baseApi + '/user/createSmsCode',
                )
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
    //短信验证码登录
export const apiLoginTel = params => {
    return new Promise((resolve, reject) => {
        instance.post(
                baseApi + '/user/loginmobile',
                Qs.stringify({
                    stuPhone:params.stuPhone,
                    // stuPhone: params.stuPhone,
                    msgCode: params.msgCode,
                    sign: params.sign,
                    type: 1
                })
            )
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                reject(error)
            })
    })
}

//忘记密码
export const apiForget = params => {
        return new Promise((resolve, reject) => {
            instance.post(
                    baseApi + '/user/phonefindpwd',
                    Qs.stringify({
                        newPwd: jsencrypt.encrypt(params.newPwd),
                        stuPhone: jsencrypt.encrypt(params.phone),
                        /* newPwd: params.newPwd,
                        stuPhone: params.phone, */
                        msgCode: params.msgCode,
                        sign: params.sign,
                        publicKey: publicKey
                    })
                )
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
    //注册
export const apiRegister = params => {
        return new Promise((resolve, reject) => {
            instance.post(
                    baseApi + '/user/register',
                    Qs.stringify({
                        "stu.stuUsername": jsencrypt.encrypt(params.stuUsername),
                        "stu.stuPassword": jsencrypt.encrypt(params.stuPassword),
                        "stu.stuMobile": jsencrypt.encrypt(params.stuMobile),
                        /* "stu.stuUsername": params.stuUsername,
                        "stu.stuPassword": params.stuPassword, */
                        "stu.stuEmail": params.stuEmail,
                        "stu.stuName": params.stuName,
                        // "stu.stuMobile": params.stuMobile,
                        "stu.stuExam": params.stuExam,
                        "stu.stuArea": params.stuArea,
                        msgCode: params.msgCode,
                        sign: params.sign,
                        stuType: 13,
                        publicKey: publicKey
                    })
                )
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
    //set验证图形验证码
export const apiSetCheckYzm = params => {
    return new Promise((resolve, reject) => {
        instance.post(
                baseApi + '/user/verifyimgcode',
                Qs.stringify({
                    imgCode: params.imgCode
                })
            )
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                reject(error)
            })
    })
}

//set获取手机验证码
export const apiGetPyzm = params => {
        return new Promise((resolve, reject) => {
            instance.post(
                    baseApi + '/user/sendSmsCode',
                    Qs.stringify({
                        "sign": jsencrypt.encrypt(params.sign),
                        "type": params.type
                    })
                )
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
    //注册--用户名验证
export const apiValidateUserName = params => {
        return new Promise((resolve, reject) => {
            instance.post(
                    baseApi + '/user/checkUsername',
                    Qs.stringify({
                        username: params.username,
                    })
                )
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
    //set验证手机号码是否绑定
export const apiIsBindPhone = params => {
        return new Promise((resolve, reject) => {
            instance.post(
                    baseApi + '/user/checkMobile',
                    Qs.stringify({
                        phone: params.phone
                    })
                )
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
    //获取项目下的所有微视频
export const apiGetAllNoTypeCourseList = params => {
    return new Promise((resolve, reject) => {
        instance.post(
                baseApi + '/member/findClassDetailList',
                Qs.stringify({
                    "page": params.page,
                    "pagesize": params.pagesize,
                    "examPid": params.examPid,
                    "isOpenTime":1,
                    "typeId":73,
                    "sortType":params.sortType
                })
            )
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                reject(error)
            })
    })
}

//获取项目下的type，1：热门考点；2：习题讲解的所有课程
export const apiGetAllTypeCourseList = params => {
    return new Promise((resolve, reject) => {
        instance.post(
                baseApi + '/member/findClassDetailList',
                Qs.stringify({
                    "page": params.page,
                    "pagesize": params.pagesize,
                    "type": params.type,
                    "examPid":params.examPid,
                    "isOpenTime":1,
                    "typeId":73,
                    "sortType":params.sortType
                })
            )
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                reject(error)
            })
    })
}

//获取项目下的热门考点，习题讲解对应科目的所有课程
export const apiGetSomeTypeCourseList = params => {
    return new Promise((resolve, reject) => {
        instance.post(
                baseApi + '/member/findClassDetailList',
                Qs.stringify({
                    "page": params.page,
                    "pagesize": params.pagesize,
                    "examId": params.examId,
                    "examPid": params.examPid,
                    "type": params.type,
                    "isOpenTime":1,
                    "typeId":73,
                    "sortType":params.sortType
                })
            )
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                reject(error)
            })
    })
}

//获取名师分享，学霸分享
export const apiGetFameShare = params => {
        return new Promise((resolve, reject) => {
            instance.post(
                    baseApi + '/member/explain',
                    Qs.stringify({
                        "flag": 0,
                        "page": params.page,
                        "pagesize": params.pagesize,
                        "type": params.type,
                        "sortType": params.sortType,
                    })
                )
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
    //获取视频信息
// 从服务器上获取实时的时长
export const apiTimeNow = params => {
    return new Promise((resolve, reject) => {
        instance.post(
            baseApi + '/v2/synchronize/time',
        )
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                reject(error)
            })
    })
}
export const apiGetVideoUrl = params => {
        return new Promise((resolve, reject) => {
            instance.post(
                    baseApi + '/member/lookMicroVideo',
                    Qs.stringify({
                        "classId": params.classId,
                        "gradeId": params.gradeId,
                    })
                )
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
    // 视频改版--添加听课记录  start
export const apiVideoAddRecord = params => {
        return new Promise((resolve, reject) => {
            instance.post(
                    //baseApi + '/course/addstudyrecord',
                baseApi + '/v2/logs/study/send',
                    Qs.stringify({
                        "logs":params.logs,
                        "lookTime": params.lookTime,
                        "studyTime": params.studyTime,
                        "type":params.type,
                        "recordIp": 'PC-wsp',
                    })
                )
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
    // 视频改版--添加听课记录  end
    // 视频改版--查找课程简介  start
export const apiVideoFindCourseDetail = params => {
        return new Promise((resolve, reject) => {
            instance.post(
                    baseApi + '/course/findclassdetail',
                    Qs.stringify({
                        "classId": params.classId,
                    })
                )
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
    // 视频改版--查找课程简介  end
    // 视频改版--老师评论--查找老师  start
export const apiVideoFindTeacher = params => {
        return new Promise((resolve, reject) => {
            instance.post(
                    baseApi + '/teacher/findteacher',
                    Qs.stringify({
                        "tchId": params.tchId,
                    })
                )
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
    // 视频改版--老师评论--查找老师  end
    // 视频改版--老师评论--查找老师评论列表  start
export const apiVideoFindComment = params => {
        return new Promise((resolve, reject) => {
            instance.post(
                    baseApi + '/comment/commentlist',
                    Qs.stringify({
                        "page": params.page,
                        "pagesize": params.pagesize,
                        "tchId": params.tchId,
                    })
                )
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
    // 视频改版--老师评论--查找老师评论列表  end
    // 视频改版--老师评论--添加评论  start
export const apiVideoAddComment = params => {
        return new Promise((resolve, reject) => {
            instance.post(
                    baseApi + '/comment/savecomment',
                    Qs.stringify({
                        "tchId": params.tchId,
                        "score": params.score,
                        "content": params.content,
                    })
                )
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
    // 视频改版--老师评论--添加评论  end
    // 课程中心--课程视频--学习答疑已解决
export const apiGetClassVideoQs = params => {
        return new Promise((resolve, reject) => {
            instance.post(
                    baseApi + '/member/myQuestionJson',
                    Qs.stringify({
                        "questionStatus": 1,
                        "classId": params.classId,
                        "page": params.page,
                        "pagesize": params.pagesize,
                    })
                )
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
    // 课程中心--学习答疑--提问时加载已开通班级的详细班级接口
export const apiAskQuestions = params => {
        return new Promise((resolve, reject) => {
            instance.post(
                    baseApi + '/member/saveQuestion',
                    Qs.stringify({
                        "classId": params.classId,
                        "gradeId": params.gradeId,
                        "questionSource": 0,
                        "questionTitle": params.questionTitle,
                        "questionContent": params.questionContent,
                    })
                )
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
    // 视频改版--学习答疑--查找examId  start
export const apiVideoFindLnExamId = params => {
        return new Promise((resolve, reject) => {
            instance.post(
                    baseApi + '/course/findexampid',
                    Qs.stringify({
                        "examId": params.examId,
                    })
                )
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
    // 视频改版--学习答疑--查找examId  end
    // 视频改版--学习笔记--记笔记  start
export const apiVideoAddNote = params => {
        return new Promise((resolve, reject) => {
            instance.post(
                    baseApi + '/note/addnote',
                    Qs.stringify({
                        "classId": params.classId,
                        "noteContent": params.noteContent,
                        "noteCouresType": '',
                        "noteVideotime": params.noteVideotime,
                    })
                )
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
    // 视频改版--学习笔记--记笔记  end
    // 视频改版--学习笔记--查询笔记  start
export const apiVideoSearchNote = params => {
        return new Promise((resolve, reject) => {
            instance.post(
                    baseApi + '/note/notelist',
                    Qs.stringify({
                        "classId": params.classId,
                        "page": params.page,
                        "pagesize": params.pagesize,
                    })
                )
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
    // 视频改版--学习笔记--查询笔记  end